import {MenuItem, Select} from '@material-ui/core';
import React, {useEffect} from 'react';
import wrap from 'wraptile';
import {Genre, SubGenre} from '../../types';

export interface GenresContainerProps {
    setQcGenres: any;
    genres: Genre[];
    isLoading: boolean;
    genreFieldValue: string;
    genreFieldChange: (event: React.ChangeEvent<any>) => void;
}

export const handleFetchGenres = wrap((setQcGenres: () => void) => {
    setQcGenres();
});

export const mapSubAndGenresLabel = (genre: Genre | SubGenre) => genre.label;

export const mapGenres = (genre: string) => (
    <MenuItem
        key={genre}
        value={genre}
    >
        {genre}
    </MenuItem>
);

export const GenresContainer = (props: GenresContainerProps) => {
    const {
        genreFieldValue,
        genreFieldChange,
        setQcGenres,
        genres,
    } = props;
    const fetchGenres = handleFetchGenres(setQcGenres);
    
    useEffect(fetchGenres, []);
    
    const genreLabels = genres.map(mapSubAndGenresLabel);
    
    return (
        <Select
            className="qc-metadata__editable-item"
            value={genreFieldValue}
            onChange={genreFieldChange}
        >
            {genreLabels.map(mapGenres)}
        </Select>
    );
};
